module.exports = "/assets/65f5ab6c34cb1ff0a7a7c67414a6cd23.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XY.png
// module id = 3131
// module chunks = 0